<template>
  <div>
    <myHeader />
    <div class="bg">
      <div class="contain">
        <div class="headcenter">
          <h1>hecoos Mirror Projection Track Lens</h1>
          <p>
            The hecoos Mirror Projection Track Lens provides flexible and diverse control over projection images, eliminating the limitations of fixed projectors that are restricted to projecting in a single, fixed direction on a surface.
          </p>
          <div class="callMe" @click="jumpTo('/en/CaseDemonstration#CallMe')">Contact us</div>
          <!-- <div class="contain_button">
            <router-link to="/CaseDemonstration">
              <button class="contact-button">联系我们</button>
            </router-link>
          </div> -->
        </div>
      </div>
    </div>

    <div class="bg1">
      <div class="foundation_video">
        <div class="video_start" style="width:100%">
          <h1>Illuminating Visions</h1>
          <button class="watch-movie-button " @click="showVideo">
            <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
          </button>
        </div>
        <video autoplay loop muted playsinline webkit-playsinline x5-playsinline x-webkit-airplay="allow"
          src="https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"></video>
      </div>
    </div>

    <div class="bg2">
      <div class="bg22">
        <!-- <p>Hardware Specifications</p> -->
        <h1>Hardware Specifications</h1>
        <img src="../../../asset/mobile/mobile_projectorbit/parameter.png" />
      </div>
    </div>
    <!-- 内容部分 -->
    <div class="bg3">
      <div>
        <div class="con11">
          <h1>Technical Specifications</h1>
        </div>
        <div class="contain1">
          <div class="con1">
            <p>Device Dimensions (W/D/H):</p>
            <p>Projection Module Weight:</p>
            <p>Device Weight:</p>
            <p>Single Mirror Weight:</p>
            <p>Truss-Mounted Bracket MHZ-BT Weight:</p>
            <p>Wall-Mounted Bracket MHZ-BW Weight:</p>
            <p>Extended Mounting Bracket MHZ-BT-BW Weight:</p>
            <p>Base Weight MHZ-BSH:</p>
          </div>
          <div class="con2">
            <p>{{ specParams.deviceSize }}</p>
            <p>{{ specParams.totalWeight }}</p>
            <p>{{ specParams.projectorWeight }}</p>
            <p>{{ specParams.mirrorWeight }}</p>
            <p>{{ specParams.btMountWeight }}</p>
            <p>{{ specParams.bwMountWeight }}</p>
            <p>{{ specParams.beMountWeight }}</p>
            <p>{{ specParams.bshMountWeight }}</p>
          </div>
        </div>
      </div>

      <div class="content2">
        <div class="con11">
          <h1>Electrical Specifications</h1>
        </div>
        <div class="contain1">
          <div class="con1">
            <p>Input Power:</p>
            <p>Output Power：</p>
          </div>
          <div class="con2">
            <p>{{ electricSpecs.inputPower }}</p>
            <p>{{ electricSpecs.outputPower }}</p>
          </div>
        </div>
      </div>
      <div class="content3">
        <div class="con11">
          <h1>Operational Specifications</h1>
        </div>

        <div class="contain1">
          <div class="con1">
            <p>Track mirror tilt mode：</p>
            <p>Track mirror pan mode:</p>
            <p>Positioning accuracy error：</p>
            <p>Relocation Accuracy：</p>
          </div>
          <div class="con2">
            <p>{{ operationSpecs.tiltMode }}</p>
            <p>{{ operationSpecs.panMode }}</p>
            <p>{{ operationSpecs.positionError }}</p>
            <p>{{ operationSpecs.movementPrecision }}</p>
          </div>
        </div>
      </div>
      <div class="content4">
        <div class="con11">
          <h1>Operating Environment</h1>
        </div>

        <div class="con1">
          <p>Working Temperature Range:5°-35°C</p>
          <p>Humidity:20%-80%(non-condensing)</p>
        </div>
        <div class="con2"></div>
      </div>
      <div class="content5">
        <div class="con11">
          <h1>Included Accessories</h1>
        </div>
        <div class="con1">
          <p>RS232 Connection Cable</p>
          <p>AC circuit cable</p>
          <p>Quick Setup Guide</p>
        </div>
        <div class="con2"></div>
      </div>
    </div>
    <!-- 作品部分 -->
    <div class="bg4">
      <div>
        <div class="foundation_video">

          <video autoplay loop muted playsinline webkit-playsinline x5-playsinline x-webkit-airplay="allow"
            src="https://download.hecoos.com/enlightv/2025-17/4339ee88fdfb051af80a4a26f1830572.mp4"></video>
          <div class="video_start">
            <button class="watch-movie-button" @click="showVideo2">
              <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <myInquire />
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import myInquire from "@/components/en_mobile/myInquire.vue";
import videoPlayback from "@/components/en_mobile/videoPlayback.vue";
export default {

  components: { myFooter, myHeader, myInquire, videoPlayback },
  data() {
    return {
      videoUrl: '',
      showVideoPlayer: false,
      specParams: {
        deviceSize: "498mmx265mmx749mm",
        totalWeight: "25.8kg",
        projectorWeight: "16.3kg",
        mirrorWeight: "9.3kg",
        btMountWeight: "2.2kg",
        bwMountWeight: "2.8kg",
        beMountWeight: "3.3kg",
        bshMountWeight: "12.5Kg",
      },
      electricSpecs: {
        inputPower: "100-240V/2-1A/50-60Hz, maximum 10A (3-pin C14 socket)",
        outputPower: "Projector AC circuit slot (3-pin C13 socket)",
      },
      operationSpecs: {
        tiltMode: "90° and 162°",
        panMode: "180°",
        positionError: "<0.03°",
        movementPrecision: "Translation or tilt in the same direction to the set position, with an error of approximately 0.01",
      },
      environmentSpecs: {
        temperatureRange: "5°-35°C",
        humidity: "20%-80%(无冷凝)",
      },
      textaerass: {
        titletext: "《致敬生命拯救者》光影行为艺术",
        pagetext:
          "2021新年伊始，在天津广播电视塔2021跨年灯光秀上，一场4分30秒的“光影行为艺术”《致敬生命拯救者》在天津广播电视塔上呈现了一个唯美又惊心动魄的故事。在呈现过程中，主创团队使用hecoos Mirror与Server-R媒体服务器配合保障作品的呈现。画面最高点在现场呈现时，主创团队使用轨道镜、高流明工程投影仪、hecoos全域媒体创作平台等前沿的硬软体媒介来保证实验过程与现场呈现的真实度。投影机配载自主编程的轨道镜系统进行建筑体投射，画面最高点达260米，也使得这件作品成为在投射范围、设备使用极简性上的一件代表性投影作品。",
      },
      formData: {
        name: "",
        phone: "",
        city: "",
        email: "",
        company: "",
        position: "",
        message: "",
      },
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      // 在此处添加表单提交后的处理逻辑，例如发送数据到服务器
      console.log(this.formData);
    },
    // 显示视频播放器
    showVideo() {
      this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4",
        this.showVideoPlayer = true;
      console.log(1);
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    showVideo2() {
      this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/f441eac9aa01246106ff61af11ddefd5.mp4",
        this.showVideoPlayer = true;
      console.log(2);
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
     jumpTo(url) {
      this.$router.push(url);
    },
  },
};
</script>


<style lang="scss" scoped>
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      color: white;
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
     @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
.bg {
  background: black;
  background-image: url("../../../asset/mobile/mobile_projectorbit/hero.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

option {
  font-size: 12px;
  /* 对选中的<option>设置文字大小 */
}

.bg p {
  font-size: 14px;
  line-height: 25px;
}

select#city option {
  font-size: 12px;
}

.contact-button {
  background-color: white;
  /* 白色背景 */
  border: none;
  border-radius: 20px;
  /* 圆角效果 */
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.5s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  /* 阴影效果 */
}

.contact-button:hover {
  background-color: black;
  color: white;
  transform: scale(1.05);
}

.contain {
  padding: 0px 43px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  height: 36vh;
}

.contain h1 {
  font-size: 26px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;

}

.contain p {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  font-family: YourFontName2;
}

.contain_button {
  display: flex;
  justify-content: center;
}

.bg1 {
  background-color: black;
  text-align: center;

}

.bg1 video {
  width: 100%;
}

.bg1 img {
  width: 100%;
}

.bg2 img {
  width: 100%;
}

.bg1 h1 {
  font-size: 26px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  text-align: center;

}

.bg2 {
  background-color: black;
  text-align: left;
  padding: 20px 43px;
}

.bg2 p {
  color: white;
  font-size: 14px;
  padding: 5px 0;
}

.bg2 h1 {
  color: white;
  font-size: 26px;
}

.bg3 {
  /* background-image: url("../../../asset/mobile/mobile_projectorbit/rectangle.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; */
  background-color: black;
  padding: 20px 43px;
}

.bg3 p {
  line-height: 25px;
  font-size: 14px;
}

.bg4 {
  background: black;
  text-align: center;
  padding: 20px 0px;
}

.bg4 h1 {
  font-size: 26px;
  color: white;
  text-align: center;
}

.qq {
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  color: white;
  padding: 10px 43px;

  margin: 0 auto;
}

.qq1 {
  margin: 0 auto;
}

.qq1 p {
  font-family: YourFontName2;
}

.bg4text p {
  text-align: left;
  color: white;
  margin: 0 auto;
  font-size: 12px;

  line-height: 20px;
  padding: 10px 43px;
}

.bg4text video {
  width: 100%;
  padding: 0px 43px;
}

.contain1 {
  display: flex;
  justify-content: left;
  padding-bottom: 20px;
}

.con11 {
  color: white;
  border-top: 1px solid white;
  padding: 20px 0px;
}

.con11 h1 {
  font-size: 17px;
  font-family: YourFontName2;
}

.con1 {
  color: white;
  font-weight: bold;
  width: 50%;
}

.content4 {
  padding-bottom: 20px;
}

.con1 p {
  font-family: YourFontName2;
  font-size: 12px;
  line-height: 20px;
}

.contain {
  display: flex;
  justify-content: center;
}

.con2 {
  color: #a6a6a6;
}

.con2 p {
  font-family: YourFontName2;
  color: rgba(166, 166, 166, 1);
  line-height: 20px;
  font-size: 12px;
}

.contact-form {
  color: #fff;
  text-align: center;
}

.form-row {
  margin-bottom: 8px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}

.form-row select::placeholder {
  color: #ffffff;
  font-size: 8px;
}

.form-row input,
.form-row select {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 50%;
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}

.form-row input::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  padding: 5px;
}

.button-container button {
  padding: 5px 30px;
  background-color: #147cf5;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  /* 水平居中 */
}

.contact-form h1 {
  font-size: 26px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  padding: 0px 43px;
}

.contact-form p {
  font-size: 12px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  line-height: 20px;
}

.bg5 {
  background: black;
  padding: 20px 43px;
}

.foundation_video {
  width: 100%;
  position: sticky;
  top: 0;
  justify-content: center;
  align-items: center;
  object-fit: cover;

}

.watch-movie-button {
  width: 32px;
  height: 32px;
  border-radius: 36.65px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.1);
}

.video_start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 999;


}

.video_start img {
  width: 100%;
}

.foundation_video video {
  width: 100%;
  object-fit: cover;
}
@media screen and (min-width: 768px){
  .bg {
  background: black;
  background-image: url("../../../asset/mobile/mobile_projectorbit/hero.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

option {
  font-size: 12px;
  /* 对选中的<option>设置文字大小 */
}

.bg p {
  font-size: 14px;
  line-height: 25px;
}

select#city option {
  font-size: 12px;
}

.contact-button {
  background-color: white;
  /* 白色背景 */
  border: none;
  border-radius: 20px;
  /* 圆角效果 */
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.5s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  /* 阴影效果 */
}

.contact-button:hover {
  background-color: black;
  color: white;
  transform: scale(1.05);
}

.contain {
  padding: 0px 43px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  height: 36vh;
}

.contain h1 {
  font-size: 50px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;

}

.contain p {
  font-size: 20px;
  font-weight: 400;
  line-height: 25px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  font-family: YourFontName2;
}

.contain_button {
  display: flex;
  justify-content: center;
}

.bg1 {
  background-color: black;
  text-align: center;

}

.bg1 video {
  width: 100%;
}

.bg1 img {
  width: 100%;
}

.bg2 img {
  width: 100%;
}

.bg1 h1 {
  font-size: 26px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  text-align: center;

}

.bg2 {
  background-color: black;
  text-align: left;
  padding: 20px 43px;
}

.bg2 p {
  color: white;
  font-size: 20px;
  padding: 5px 0;
}

.bg2 h1 {
  color: white;
  font-size: 40px;
}

.bg3 {
  /* background-image: url("../../../asset/mobile/mobile_projectorbit/rectangle.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; */
  background-color: black;
  padding: 20px 43px;
}

.bg3 p {
  line-height: 25px;
  font-size: 14px;
}

.bg4 {
  background: black;
  text-align: center;
  padding: 20px 0px;
}

.bg4 h1 {
  font-size: 26px;
  color: white;
  text-align: center;
}

.qq {
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  color: white;
  padding: 10px 43px;

  margin: 0 auto;
}

.qq1 {
  margin: 0 auto;
}

.qq1 p {
  font-family: YourFontName2;
}

.bg4text p {
  text-align: left;
  color: white;
  margin: 0 auto;
  font-size: 12px;

  line-height: 20px;
  padding: 10px 43px;
}

.bg4text video {
  width: 100%;
  padding: 0px 43px;
}

.contain1 {
  display: flex;
  justify-content: left;
  padding-bottom: 20px;
}

.con11 {
  color: white;
  border-top: 1px solid white;
  padding: 20px 0px;
}

.con11 h1 {
  font-size: 26px;
  font-family: YourFontName2;
}

.con1 {
  color: white;
  font-weight: bold;
  width: 50%;
}

.content4 {
  padding-bottom: 20px;
}

.con1 p {
  font-family: YourFontName2;
  font-size: 18px;
  line-height: 25px;
}

.contain {
  display: flex;
  justify-content: center;
}

.con2 {
  color: #a6a6a6;
}

.con2 p {
  font-family: YourFontName2;
  color: rgba(166, 166, 166, 1);
  line-height: 25px;
  font-size: 18px;
}

.contact-form {
  color: #fff;
  text-align: center;
}

.form-row {
  margin-bottom: 8px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}

.form-row select::placeholder {
  color: #ffffff;
  font-size: 8px;
}

.form-row input,
.form-row select {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 50%;
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}

.form-row input::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  padding: 5px;
}

.button-container button {
  padding: 5px 30px;
  background-color: #147cf5;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  /* 水平居中 */
}

.contact-form h1 {
  font-size: 26px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  padding: 0px 43px;
}

.contact-form p {
  font-size: 12px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  line-height: 20px;
}

.bg5 {
  background: black;
  padding: 20px 43px;
}

.foundation_video {
  width: 100%;
  position: sticky;
  top: 0;
  justify-content: center;
  align-items: center;
  object-fit: cover;

}

.watch-movie-button {
  width: 46px;
  height: 46px;
  border-radius: 36.65px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.1);
}

.video_start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 999;
  h1{
    font-size: 40px;
  }
  
}

.video_start img {
  width: 100%;
}

.foundation_video video {
  width: 100%;
  object-fit: cover;
}
}
</style>